import { parse } from './golang_parser.js'

const parser = {
  parse,
}

export default parser
